import LocaleStorageKey from '@/enums/locale-storage-key.ts';

function getDataFromLocaleStorage(dataKey: LocaleStorageKey): string | null {
  try {
    const value: string | null = localStorage.getItem(dataKey);
    return value || null;
  }
  catch (error: any) {
    console.log(`Ошибка чтения из LocalStorage ${dataKey}`, error.toString());
    return null;
  }
}

export default getDataFromLocaleStorage;
